import { render, staticRenderFns } from "./pointsExchange.vue?vue&type=template&id=603c97c4&scoped=true&"
import script from "./pointsExchange.vue?vue&type=script&lang=js&"
export * from "./pointsExchange.vue?vue&type=script&lang=js&"
import style0 from "./pointsExchange.vue?vue&type=style&index=0&id=603c97c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c97c4",
  null
  
)

export default component.exports